import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useCartUi } from './cart-ui-store';
export function CartIconAnchor({ children }) {
    const ref = useRef(null);
    const registerAnchor = useCartUi((s) => s.registerAnchor);
    useEffect(() => {
        if (!ref.current)
            return;
        return registerAnchor(ref.current);
    }, [registerAnchor]);
    return _jsx("span", { ref: ref, className: "inline-flex", children: children });
}
